<template>
  <div class="blocks"
    :style="{ 'border-bottom-color': this.bottom_color ? this.bottom_color : '' }">
    <div class="row">
      <div class="col-12 title"
        :style="{ 'color': this.header_color }">
        <!-- <i class="sprite" v-bind:src="icon"></i> -->
        <img v-bind:src="icon" />
        <div v-text="title"></div>
      </div>
    </div>
    <div class="row info">
      <div class="col-12" v-if="block_type == 'text'" editable="{ type: 'course', title: 'Python 在物理學的應用', field: 'introduce' }">
        <div v-html="info"></div>
      </div>
      <div class="col-12"
        v-if="block_type == 'list'">
        <ul class="decimal">
          <li v-for="(item, itemIndex) in info" :key="itemIndex" v-text="item"></li>
        </ul>
      </div>
      <div class="col-12 weekly"
        v-if="block_type == 'weekly'"
        :style="{ 'color': getColorValue('weeks_header', 'text', 0) }">
        <div class="row no-gutters text-center"
          v-if="has_weeks_columns_4 == false">
          <div class="col-1">週次</div>
          <div class="col-5">單元主題</div>
          <div class="col-3">教學元件</div>
          <div class="col-3">教學活動應用</div>
        </div>
        <div class="row no-gutters text-center"
          v-if="has_weeks_columns_4 == true">
          <div class="col-1" v-text="this.weeks_columns_4[0]"></div>
          <div class="col-5" v-text="this.weeks_columns_4[1]"></div>
          <div class="col-3" v-text="this.weeks_columns_4[2]"></div>
          <div class="col-3" v-text="this.weeks_columns_4[3]"></div>
        </div>
        <div class="row no-gutters weekly-item"
          v-for="(week, index) in this.weeks" :key="week.id"
          v-init="isOddItem = index % 2 == 1"
          :style="{ 'border-top-color': getColorValue('weeks.normal', '', index) }">
          <!-- week-no -->
          <div class="col-1 text-large text-center item-no"
            v-text="week.no"
            :style="{
              'color': getColorValue('weeks_no', 'text', index),
              'background-color': getColorValue('weeks.normal', '', index)
              }"></div>
          <!-- subject(s) -->
          <div class="col-5 text-large"
            v-if="Array.isArray(week.subject) == false"
            v-text="week.subject"
            :style="{ 'color': getColorValue('weeks.text', '#fff', index) }">
          </div>
          <div class="col-5 text-large"
            v-if="Array.isArray(week.subject)"
            :style="{ 'color': getColorValue('weeks.text', '#fff', index) }">
            <div v-for="subject in week.subject" :key="subject" v-html="subject"></div>
          </div>
          <!-- parts -->
          <div class="col-3">
            <div class="parts"
              v-for="(part, partIndex) in week.parts" :key="part.id"
              v-init="_applications = getMappedApplications(part.application_id, true, part)"
              :style="{ 'color': getColorValue('weeks.text_part', 'weeks.text', index), 'border-left-color': getColorValue('weeks.normal', '', index) }"
              >
              <div class="parts-container"
                :style="{ 'border-left-color': getColorValue('weeks.normal', '', index) }">
                <div class="part"
                  :class="part['css_class']">
                  <i class="sprite"
                    :class="{ 'sprite-page_PLAY01': isOddItem == false, 'sprite-page_PLAY02': isOddItem == true }"
                    v-if="false"></i>
                  <img class="icon"
                    v-bind:src="isOddItem == false ? play_icons.i_01 : play_icons.i_02"
                    @mouseover="ChangeImage($event, play_icons.over)"
                    @mouseleave="ChangeBackImage($event)" />
                  <div class="item"
                    v-text="part.title"
                    @click="ShowPart(part, partIndex)" ></div>
                </div>
                <div class="part"
                  v-for="empty in part.empty_lines" :key="empty" ></div>
              </div>
            </div>
          </div>
          <!-- application mapping -->
          <div class="col-3">
            <div class="parts"
              v-for="(part, partIndex) in week.parts" :key="part.id"
              v-init="_applications = getMappedApplications(part.application_id, true, part)"
              >
                <div class="parts-container"
                  v-if="_applications.length > 0 && checkIsNeedToShow(week.parts, partIndex)"
                  :style="{ 'border-left-color': getColorValue('weeks.normal', '', index) }">
                  <div class="part"
                    :class="part['application_css_class']"
                    v-for="(application_title, appIndex) in _applications" :key="appIndex">
                    <i class="sprite"
                      :class="{ 'sprite-page_PLAY01': isOddItem == false, 'sprite-page_PLAY02': isOddItem == true }"
                      v-if="false && checkIsNeedToShow(week.parts, partIndex)"></i>
                    <img class="icon"
                      v-bind:src="isOddItem == false ? read_icons.i_01 : read_icons.i_02"
                      v-if="true || checkIsNeedToShow(week.parts, partIndex)"
                      @mouseover="ChangeImage($event, read_icons.over, true)"
                      @mouseleave="ChangeBackImage($event, true)" />
                    <div class="item"
                      v-html="application_title == '' ? '&nbsp;' : application_title"></div>
                  </div>
                </div>
                <div class="parts-container"
                  v-if="part['description'] !== undefined"
                  :style="{ 'border-left-color': getColorValue('weeks.normal', '', index) }">
                  <div class="icon-container">
                    <img class="icon icon-description"
                        v-bind:src="isOddItem == false ? read_icons.i_01 : read_icons.i_02"
                        v-if="true || checkIsNeedToShow(week.parts, partIndex)"
                        @mouseover="ChangeImage($event, read_icons.over, true)"
                        @mouseleave="ChangeBackImage($event, true)" />
                  </div>
                  <div class="part description" v-html="part.description"></div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <video-js ref="video"></video-js>
    <photo-viewer ref="photo"></photo-viewer>
  </div>
</template>
<script>
import _ from 'lodash'
import VideoJS from '@/components/VideoJS'
import PhotoViewer from '@/components/PhotoViewer'

import { courseMixin } from './_Mixins'

// OK: 一個單元會有對應多個 "教學應用" 的情況, confirmed by line with 佳琦 @ 2019-5-27 21:12

export default {
  data () {
    return {
      // 'block_type': 'text',
      settings: null,
    }
  },

  props: [
    'prefix',
    'title',
    'info',
    'icon',
    'header_color',
    'bottom_color',
    'play_icons',
    'read_icons',
    'item_type' ],

  mounted () {
    //if (!this.item_type) this.item_type = 'text'

  },

  mixins: [ courseMixin ],

  components: {
    'video-js': VideoJS,
    'photo-viewer': PhotoViewer,
  },

  methods: {
    openUrl(url) {
      window.open(url, `_blank_${url}`)
    },

    showPhoto(src) {
      this.$refs.photo.open(src)
    },

    playVideo(src, partIndex) {
      //console.log('SeriesList.vue', 'play video', this.$emit)
      this.$refs.video.play(src)
      // console.log(this.$refs)
    },

    ShowPart(part) {
      // if (!this.info || this.info == undefined) return

      if (!part || part == undefined) return

      // debugger
      if (part['part_type'] && part['src']) {

        let type = part['part_type'].toLowerCase()
        let src = part['src']

        //if (src.startsWith('http') == false && src.startsWith('//')) {
        // if (type == 'url') {
        //   let prefix = this.course_prefix
        //   src = `http://media-dlc.scenet.net/videos/${prefix}${src}`
        // }
        // else {
        //   //src = `http://media-dlc.sce.pccu.edu.tw/deep/${prefix}/${src}`
        //   src = `http://media-dlc.scenet.net/videos/${previx}${src}`
        // }

        let isAlreadyUrl = src.startsWith('http') == true || src.startsWith('//') == true;

        console.log('CourseIntroduceBlock.vue (before) ', isAlreadyUrl, src)

        // console.log('CourseIntroduceBlock.vue', isAlreadyUrl)
        if (isAlreadyUrl == false) {
          console.log('CourseIntroduceBlock.vue . this.combineFullResourceUrl : ', this.combineFullResourceUrl)

          src = this.combineFullResourceUrl(src)
        }

        console.log('CourseIntroduceBlock.vue (after) ', isAlreadyUrl, src)

        // console.log(this)
        // console.log(isAlreadyUrl)
        // console.log(type)
        // console.log(src)
        // return
        // debugger

        if (type == 'url') {
          this.openUrl(src)
          return
        }

        if (type == 'video') {
          this.playVideo(src)
          return
        }

        if (type == 'photo') {
          this.showPhoto(src)
          return
        }
      }

      return
    },

    ChangeImage($event, new_icon, disabled = false) {
      if (disabled) return

      $event.target.original_src = $event.target.src
      $event.target.src = new_icon
    },

    ChangeBackImage($event, disabled = false) {
      if (disabled) return

      if ($event.target['original_src']) {
        $event.target.src = $event.target.original_src
      }
    },

    checkIsNeedToShowForApplication(parts, partIndex) {
      if (!parts) return false

      if (partIndex == 0) return true

      if (parts[partIndex - 1].application_id != parts[partIndex].application_id) {
        return true
      }

      // current application same as previous part
      let origin_partIndex = partIndex - 1
      if (parts[partIndex - 1]['mapping_partIndex']) {
        origin_partIndex = parts[partIndex - 1]['mapping_partIndex']
      }
      parts[partIndex]['mapping_partIndex'] = origin_partIndex

      if (!parts[origin_partIndex]['total_lines']) {
        parts[origin_partIndex]['total_lines'] = 2
      }
      else {
        parts[origin_partIndex]['total_lines'] += 1
      }

      return false
    },

    checkIsNeedToShow(parts, partIndex) {
      if (!parts) return false

      if (partIndex == 0) return true

      if (parts[partIndex - 1].application_id != parts[partIndex].application_id) {
        return true
      }

      // current application same as previous part
      return false
    },

    getMappedApplications (application_id, is_need_to_show, part) {
      if (is_need_to_show == false) return []

      let applications = this.info.applications

      if (!applications) return []

      let application_title_array = []

      if (Array.isArray(application_id)) {
        // application is array

        application_id.forEach((id) => {
          let index = _.findIndex(applications, { id: id })

          if (index != -1) {
            application_title_array.push(applications[index].title)
          }

          if (application_title_array.length > 1) {
            if (!part['empty_lines']) {
              part.empty_lines = []
            }

            part.empty_lines.push(application_title_array.length - 1)
          }
        })

        return application_title_array
      }

      let index = _.findIndex(applications, { id: application_id })
      if (index == -1) return []

      //return applications[index].title
      application_title_array.push(applications[index].title)

      return application_title_array
    },

    getColorValue(key, defaultValue, index) {
      let testIsKey = (value) => {
        if (value.startsWith('#'))
          return value
        else if (value == '')
          return ''

        return this.getColorValue(value, '', index)
      }
      if (!this.colors) {
        return testIsKey(defaultValue)
      }

      let isNumber = Number.isInteger(index)

      if (index !== undefined && isNumber == false) return testIsKey(defaultValue)

      if (typeof(key) == 'object') {
        let _result = eval(key.test)
        if (key[_result]) {
          key = key[_result]
        }
        else {
          key = 'text'
        }
        //debugger
      }

      let keys = key.split('.')
      var currentItem = this.colors;
      for (var i = 0; i < keys.length; i++) {
        if (!currentItem) break;

        key = keys[i]

        // if (key == 'main') debugger

        if (!currentItem[key]) {
          return testIsKey(defaultValue)
        }

        currentItem = currentItem[key]
        if (Array.isArray(currentItem)) {
          currentItem = currentItem[index % 2]
        }

        if (i == keys.length - 1) {

          if (!currentItem) {
            return testIsKey(defaultValue)
          }

          return currentItem
        }
      }

      return testIsKey(defaultValue)
    },
  },

  computed: {
    block_type() {
      if (!this.item_type)
        return 'text'
      return this.item_type
    },
    course_prefix() {
      if (this.block_type != 'weekly') return ''

      if (!this.info) return ''
      if (!this.info['id']) return ''
      //if (this.info['id'] === undefined) return 0

      // console.log(this.info.id)

      return this.info.prefix
    },
    course_id() {
      if (this.block_type != 'weekly') return -1

      if (!this.info) return 0
      if (!this.info['id']) return 0
      //if (this.info['id'] === undefined) return 0

      // console.log(this.info.id)

      return this.info.id
      // return 0
    },

    applications() {
      if (!this.info) {
        return []
      }

      return this.info.applications
    },

    has_weeks_columns_4() {
      if (!this.weeks_columns_4) return false
      if (Array.isArray(this.weeks_columns_4) && this.weeks_columns_4.length == 0) return false

      return true
    },

    weeks_columns_4() {

      if (!this.info) {
        return []
      }
      // debugger
      if (!this.info['weeks_columns_4']) {
        return []
      }

      // debugger
      if (Array.isArray(this.info['weeks_columns_4'])) {
        return this.info['weeks_columns_4']
      }

      return []
    },

    weeks() {
      if (!this.info) {
        return []
      }

      return this.info.weeks
    },

    colors: function () {
      if (typeof(this.info) == 'string') return
      if (Array.isArray(this.info)) return

      if (!this.info) {
        return
      }

      //return this.info.weeks_setting.colors
      return this.info.colors
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CourseIntroduceBlock.vue